module.exports = __webpack_public_path__ + "img/skin.1bb4ac97.png";